<template>
  <div class="outsourcing-service-section">
    <div class="background-container">
      <!-- Contenedor para el fondo -->
    </div>
    
    <div class="content-container">
      <div class="content">
        <div class="header-section">
          <h1 class="section-title">{{ translate('landing.outsourcing_title', 'OUTSOURCING') }}<br>{{ translate('landing.make_life_better', 'MAKE LIFE BETTER') }}</h1>
        </div>
        
        <!-- Sección de beneficios -->
        <div class="benefits-section">
          <div class="benefits-content">
            <h2 class="benefits-description">
              {{ translate('landing.outsourcing_subtitle', 'Best agents to take care of your customer support, sales and complains.') }}
            </h2>
            <p class="main-description">
              {{ translate('landing.outsourcing_description', 'Technopaws delivers pet-focused, cost-effective outsourcing solutions designed to keep your customers satisfied long after they leave your store. We help you scale your business, reduce daily workload, and create unforgettable client experiences-all while you stay focused on what you do best: caring for pets and their people.') }}
            </p>
          </div>
        </div>
        
        <!-- Sección de llamado a la acción -->
        <div class="action-section">
          <a @click="openTawkChat" class="cta-button button">{{ translate('landing.get_quote', 'GET A QUOTE') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'OutsourcingServiceSection',
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  },
  methods: {
    openTawkChat() {
      // Abrir el chat de tawk.to
      if (window.Tawk_API && window.Tawk_API.maximize) {
        window.Tawk_API.maximize();
      } else {
        console.warn('Tawk.to API no está disponible');
      }
    }
  }
}
</script>

<style scoped>

:root {
  /* Variables globales si son necesarias */
}

.outsourcing-service-section {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #09405c;
  overflow: hidden;
}

/* Contenedor para el fondo */
.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/technopawsImages/outsourcing.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #09405c;
  z-index: 1;
}

.content {
  width: 100%;
  gap: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  overflow-y: auto; /* Permitir scroll vertical si el contenido excede la altura */
  scrollbar-width: thin; /* Para Firefox */
  scrollbar-color: rgba(9, 64, 92, 0.5) transparent; /* Para Firefox */
}

.header-section {
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.section-title {
  color: #09405c; /* Sobrescribimos el color para este componente */
  margin: 0;
  letter-spacing: 1px;
}

.main-description {
  margin: 2rem;
  color: white;
  line-height: 1.6;
  text-align: center;
}

.benefits-description {
  color: white;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.5;
  margin-top: 0;
}

.action-section {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.cta-button {
  background-color: #09405c;
  width: 350px;
  /* El resto de propiedades ahora vienen de la clase global cta-button */
}

/* Media queries para móviles pequeños */
@media (max-width: 480px) {
  .background-container {
    background-position: center top;
  }

  .outsourcing-service-section {
    padding-top: 3rem;
    min-height: 50vh;
  }
  
  .header-section {
    padding: 1rem;
    padding: 0.8rem;
  }
  
  .section-title {
    /* Tamaño viene de media query en App.vue para h1 */
    letter-spacing: 0px;
  }

  .content {
   width: 100%;
   gap: 1rem;
  }
  
  .main-description {
    /* Tamaño viene de media query en App.vue para h4 */
    margin: 1rem;
    padding: 0;
    text-align: left;
    line-height: 1.6
  }
  
  .benefits-description {
    margin: 1rem;
    text-align: center;
  }
}
</style>
